import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { guaranteeSteps } from '../data/audit';
export function Guarantee() {
  return <section className="bg-cream-100 px-4 py-14 sm:px-6 sm:py-20" data-id="element-181" data-mp="22368xudz85ss">
      <div className="mx-auto w-full max-w-3xl" data-id="element-182" data-mp="222mzl22e6pqd">
        <div className="rounded-3xl bg-white p-6 ring-1 ring-navy-900/10 sm:p-9" data-id="element-183" data-mp="1x420x72sge41">
          <div className="flex flex-col items-center text-center" data-id="element-184" data-mp="19ehf8gf932r2">
            <span className="flex h-16 w-16 items-center justify-center rounded-full bg-navy-900" data-id="element-185" data-mp="19co8l14n0ij2">
              <ShieldCheckIcon className="h-8 w-8 text-gold-400" aria-hidden="true" data-id="element-186" data-mp="14dl35fkqwaak" />
            </span>
            <h2 className="mt-4 font-display text-2xl font-bold leading-tight text-navy-900 sm:text-3xl" data-id="element-187" data-mp="1edk8z4ps5mjq">
              7-day money-back guarantee
            </h2>
            <p className="mt-2 text-base text-navy-700/80" data-id="element-188" data-mp="lp6bqr6imu98">
              Explore the Audit risk-free.
            </p>
          </div>

          <ol className="mt-8 space-y-3" data-id="element-189" data-mp="p0b7vx1bzcgh">
            {guaranteeSteps.map((step, i) => <li key={step} className="flex items-center gap-3.5 rounded-2xl bg-cream-100 px-4 py-3.5" data-id="element-190" data-mp="ty324xpg7anu" data-mpi={i}>
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-navy-900 font-display text-sm font-bold text-gold-400" data-id="element-191" data-mp="yrfmuwr0axbb">
                  {i + 1}
                </span>
                <span className="text-[15px] font-medium leading-snug text-navy-900" data-id="element-192" data-mp="62qfifzcxvr4">
                  {step}
                </span>
              </li>)}
          </ol>

          <div className="mt-7 space-y-3 text-center text-[14px] leading-relaxed text-navy-700/80 sm:text-[15px]" data-id="element-193" data-mp="f00twa7h2109">
            <p data-id="element-194" data-mp="jyc44m1oidj0">
              See whether Dr. Karito’s system fits the way you approach complex
              rehabilitation cases.
            </p>
            <p data-id="element-195" data-mp="1vesn2pcfzcam">
              If within 7 days you decide the Audit isn’t right for you, simply
              request a refund according to the applicable guarantee terms.
            </p>
            <p className="font-bold text-navy-900" data-id="element-196" data-mp="3nhocnyipeto5">
              No long-term commitment. No subscription.
            </p>
          </div>
        </div>

        <div className="mt-10" data-id="element-197" data-mp="5aqoz64xv1mt">
          <CTAButton label="Try it risk-free" subLabel="7 days to decide · Full refund on request" data-id="element-198" data-mp="coxbwtg5tzq" />
        </div>
      </div>
    </section>;
}